import HeadingTitle from "../heading-title/HeadingTitle";
import { Image } from "../index";
import styles from "./banner.module.css";
const Banner = ({
  heading,
  imageUrl,
  altText = "Banner Image",
}) => {
  return (
    <section className={styles.bannerSection}>
      <div className={styles.bannerContainer}>
        <div className={styles.bannerImageWrapper}>
          <Image 
          src={imageUrl} 
          alt={altText} 
          className={styles.bannerImage} />
          {heading && (
            <div className={styles.bannerTextOverlay}>
              <HeadingTitle text={heading} style={styles.bannerHeading} />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
export default Banner;